import { expandFrame } from './src/frames';
import frame from './src'

let data = {}

let in_frame = vm => vm.$root.$options._isFrame

// 组件创建之前回调
function beforeCreate() {

    // if (in_frame(this)) return 

    let target = frame()

    data[this._uid] = target

    let table = {
        alert: target.alert,
        confirm: target.confirm,
        notify: target.notify,
        box: target.box
    }

    this.$frame = table
}

function mounted() {

    // if (in_frame(this)) return 

    data[this._uid].set_wrap(this.$el)
}

// 组件销毁后回调
function destroyed() {

    // if (in_frame(this)) return 

    data[this._uid] && data[this._uid].destroy()
}

// keepalive组件关闭后回调
function deactivated () {
    
    // if (in_frame(this)) return 

    data[this._uid] && data[this._uid].destroy()
}

export default {
    expandFrame,
    install: function (Vue, opts = {}) {
        Vue.mixin({
            beforeCreate,
            mounted,
            destroyed,
            deactivated
        })
    }
};
